export default __webpack_public_path__ + "static/media/04.48654d71.jpg";